import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AppLoading from "../AppLoading";
import MenuList from "../MenuList";
import logoHeader from "../Layout/assets/images/logoHeader.png";

class Regions extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      })
    ).isRequired,
    onSelect: PropTypes.func,
    application: PropTypes.object.isRequired,
    database: PropTypes.object.isRequired,
    onReload: PropTypes.func
  };

  static defaultProps = {
    onSelect: () => {},
    onReload: () => {}
  };

  renderContent = () => {
  if (this.props.application.isLoaded && this.props.database.isLoaded) {
    return (
      <MenuList
        items={this.props.items}
        itemIcon="icon-globe"
        onSelect={this.props.onSelect}
      />
    );
  }

  return (
    <AppLoading
      application={this.props.application}
      database={this.props.database}
      onReload={this.props.onReload}
    />
  );
};

  render() {
    return (
      <div className="screen-container screen-regions">
        <div className="header">
          <img src={logoHeader} alt="HWK Skiwax" />
        </div>
        <div className="content">
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

export default Regions;
